import React from 'react';

export interface CardBodyProps extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode | React.ReactNode[];
}

const CardBody: React.FC<CardBodyProps> = ({ children, ...rest }) => {
  return (
    <div className="zb-card-body" {...rest}>
      {children}
    </div>
  );
};

export default CardBody;
